import requestTradingConfig from 'config/requestTrading';
import { API_TRADING_URL_V2 } from 'constants/api';

import {
  GetSmartOrderPayload,
  CreateSmartOrderPayload,
  EditSmartOrderPayload,
  DeleteSmartOrderPayload,
  SaveTNCSmartOrderPayload,
  CreateSmartOrderResponse,
  EditSmartOrderResponse,
  DeleteSmartOrderResponse,
  GetSmartOrderResponse,
  SaveTNCSmartOrderResponse,
  ReqCreateStopOrder,
  ReqAmendStopOrder,
} from 'global/Securities/types/api/smartOrder';

import { APIResponse } from '../../../@types/api-response';

const requestTrading = requestTradingConfig(API_TRADING_URL_V2, true, false);

/**
  * @deprecated Use `postStopOrder` instead
*/
export const postSmartOrder = (
  payload: CreateSmartOrderPayload,
): Promise<APIResponse<CreateSmartOrderResponse>> =>
  requestTrading.post(`${API_TRADING_URL_V2}/smart-order`, { data: [payload] });

export const postStopOrder = (
  data: ReqCreateStopOrder,
): Promise<APIResponse<CreateSmartOrderResponse>> =>
  requestTrading.post(
    `${API_TRADING_URL_V2}/smart-order/stop-order/v1/order`,
    data,
  );

/**
 * @deprecated Use `editStopOrder` instead
 */
export const editSmartOrder = (
  payload: EditSmartOrderPayload,
): Promise<APIResponse<EditSmartOrderResponse>> =>
  requestTrading.put(`${API_TRADING_URL_V2}/smart-order`, payload);

export const editStopOrder =
  (orderId: string) =>
  async (
    data: ReqAmendStopOrder,
  ): Promise<APIResponse<EditSmartOrderResponse>> =>
    requestTrading.patch(`/smart-order/stop-order/v1/order/${orderId}`, data);

/**
 * @deprecated use deleteStopOrder instead
 */
export const smartOrderDelete = (
  payload: DeleteSmartOrderPayload,
): Promise<APIResponse<DeleteSmartOrderResponse>> =>
  requestTrading.delete(`${API_TRADING_URL_V2}/smart-order`, { data: payload });

export const deleteStopOrder = (orderId: string): Promise<APIResponse<DeleteSmartOrderResponse>> =>
  requestTrading.delete(
    `${API_TRADING_URL_V2}/smart-order/stop-order/v1/order/${orderId}`,
  );

export const getStockData = (
  payload: GetSmartOrderPayload,
): Promise<APIResponse<GetSmartOrderResponse>> =>
  requestTrading.get(`${API_TRADING_URL_V2}/smart-order`, { params: payload });

export const postSmartOrderTnC = (
  payload: SaveTNCSmartOrderPayload,
): Promise<APIResponse<SaveTNCSmartOrderResponse>> =>
  requestTrading.post(`${API_TRADING_URL_V2}/smart-order/tnc`, payload);
